import React, { useEffect, useMemo, useState } from 'react'
import { ListMagnifyingGlass } from '@phosphor-icons/react'
import LoadingScreen from '../../../components/LoadingScreen'
import RbacAuditActionChip from '../../components/history/RbacAuditActionChip'
import RbacAuditActorCell from '../../components/history/RbacAuditActorCell'
import RbacAuditDateCell from '../../components/history/RbacAuditDateCell'
import RbacAuditDetailCell from '../../components/history/RbacAuditDetailCell'
import RbacAuditHistoryTabShell from '../../components/history/RbacAuditHistoryTabShell'
import {
  buildPermissionLabelMap,
  getActionChipConfig
} from '../../components/history/rbacAuditHistoryHelpers'
import { fetchPermissionCatalog } from '../services/permissionCatalogApi'
import { RBAC_ROLE_DETAIL_TEXTS } from '../shared/rbacRoleDetailConstants'

const historyEmptyState = {
  title: 'Aún no hay ajustes registrados',
  description: 'Los cambios realizados a este rol aparecerán aquí.',
  icon: <ListMagnifyingGlass size={34} weight="regular" />
}

export default function RbacRoleHistoryTab({
  rows,
  loading,
  pagination,
  onPageChange,
  onRowsPerPageChange
}) {
  const [permissionLabelMap, setPermissionLabelMap] = useState({})

  useEffect(() => {
    let cancelled = false

    async function loadCatalog() {
      try {
        const catalog = await fetchPermissionCatalog()
        if (!cancelled) {
          setPermissionLabelMap(buildPermissionLabelMap(catalog))
        }
      } catch (_error) {
        if (!cancelled) setPermissionLabelMap({})
      }
    }

    loadCatalog()
    return () => {
      cancelled = true
    }
  }, [])

  const columns = useMemo(
    () => [
      {
        key: 'created_at',
        label: 'FECHA Y HORA',
        width: '18%',
        cellSx: { verticalAlign: 'top' },
        render: (entry) => <RbacAuditDateCell createdAt={entry.created_at} />
      },
      {
        key: 'actor',
        label: 'USUARIO',
        width: '22%',
        cellSx: { verticalAlign: 'top' },
        render: (entry) => <RbacAuditActorCell entry={entry} />
      },
      {
        key: 'action',
        label: 'ACCIÓN',
        width: '20%',
        cellSx: { verticalAlign: 'top' },
        getTitle: (entry) => getActionChipConfig('role', entry.action).label,
        render: (entry) => <RbacAuditActionChip entry={entry} context="role" />
      },
      {
        key: 'detail',
        label: 'DETALLE',
        width: '40%',
        truncate: false,
        cellSx: { verticalAlign: 'top' },
        getTitle: (entry) => entry.summary || '',
        render: (entry) => (
          <RbacAuditDetailCell
            entry={entry}
            context="role"
            permissionLabelMap={permissionLabelMap}
          />
        )
      }
    ],
    [permissionLabelMap]
  )

  if (loading) {
    return (
      <div className="container-fluid px-0">
        <LoadingScreen text={RBAC_ROLE_DETAIL_TEXTS.loading} minHeight="360px" />
      </div>
    )
  }

  return (
    <RbacAuditHistoryTabShell
      subtitle={RBAC_ROLE_DETAIL_TEXTS.historySubtitle}
      ariaLabel="Historial del rol RBAC"
      columns={columns}
      rows={rows}
      loading={false}
      emptyState={historyEmptyState}
      pagination={pagination}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      paginationAriaLabel="Paginación de historial del rol"
    />
  )
}
